export const TermsOfServiceURL = "https://www.yourbinoculars.com/terms-of-service";
export const PrivacyPolicyURL = "https://www.yourbinoculars.com/privacy-policy";
export const RefundPolicyURL = "https://www.yourbinoculars.com/refund-cancellation-policy";
export const HelpPageURL = "https://www.yourbinoculars.com/help";
